import { CommonModule } from '@angular/common';
import { Component, forwardRef, Input, OnInit } from '@angular/core';
import { ControlValueAccessor, FormControl, NG_VALUE_ACCESSOR, ReactiveFormsModule, Validators } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { TranslateModule } from '@ngx-translate/core';

/**
 * This component allows to insert a time slice hours:minutes.
 * 
 * The data is returned in a simple string format (HH:mm)
 * 
 */
@Component({
  selector: 'input-time',
  standalone: true,
  imports: [CommonModule,
    MatFormFieldModule,
    MatInputModule,
    ReactiveFormsModule,
    TranslateModule
  ],
  templateUrl: './input-time.component.html',
  styleUrl: './input-time.component.css',
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => InputTimeComponent),
      multi: true
    }
  ]
})
export class InputTimeComponent implements ControlValueAccessor, OnInit {
  @Input() label = "time"
  @Input() required = false;
  @Input() readonly = false;
  @Input() formFieldClass: string = '';
  @Input() requiredLabel: string = 'required-time';

  control = new FormControl<number | null>(null);


  onChange = (value: number | null) => { };
  onTouched = () => { };

  ngOnInit(): void {
    const validators = [];

    if (this.required) {
      validators.push(Validators.required);
    }

    this.control.setValidators(validators);

    this.control.valueChanges.subscribe(value => {
      this.onChange(value);
      this.onTouched();
    });
  }

  writeValue(value: number | null): void {
    this.control.setValue(value, { emitEvent: false });
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  setDisabledState(isDisabled: boolean): void {
    isDisabled ? this.control.disable() : this.control.enable();
  }
}
